/** Просьба разрешить боту писать — подключение к стору и колбэкам. */
import type { WindowProps } from "../kit";
import { registerWindow } from "../../../app";
import { WriteAccessView } from "./view";
import { actions } from "../actions";

declare module "../../../app/state/window-route" {
  interface WindowRoutes {
    writeAccess: object;
  }
}

export function WriteAccess({ close }: WindowProps<"writeAccess">) {
  const answer = (allow: boolean): void => {
    actions().answerWriteAccess(allow);
    close();
  };
  return <WriteAccessView onAllow={() => answer(true)} onDecline={() => answer(false)} />;
}

export function register(): void {
  registerWindow("writeAccess", WriteAccess);
}
